import BaseDrawingObject from "./baseDrawingObject";

class Container extends BaseDrawingObject {
    constructor(position, transformations) {
        super();
        this.type = 'container';
        
        this.position = position || { x: 0, y: 0 };
        this.transformations = transformations ? JSON.parse(JSON.stringify(transformations)) : null;
    }

    setPosition(x, y) {
        this.position = { x: x, y: y };
        return this;
    }

    setTransformations(transformations) {
        this.transformations = JSON.parse(JSON.stringify(transformations));
        return this;
    }

    getTransformations() {
        return this.transformations;
    }
    
    setAdjustOriginForLocalGeometryAndChildren(newValue) {
        this.adjustOriginForLocalGeometryAndChildren = newValue;
        return this;
    }

    getAdjustOriginForLocalGeometryAndChildren() {
        return this.adjustOriginForLocalGeometryAndChildren;
    }
}

export default Container;